import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { getProfile } from 'services';

export const siPayInitialize = (dispatch: Dispatch<AnyAction>) => {
    return new Promise((res) => getProfile(dispatch).then(() => res(true)));
};